import React, { memo } from 'react';
import { Button, TableCell, Tooltip } from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import { PointOfSale } from '@mui/icons-material';
import { User } from '../types';

interface UserActionsButtonsProps {
  user: User;
  currentUserRole: string | null;
  onOpenActionsDialog: (user: User) => void;
  onToggleActivation: (user: User) => void;
  onTogglePOS: (user: User) => void;
  onToggleReports: (user: User) => void;
  onOpenDeleteDialog: (user: User) => void;
  isActivationButtonDisabled: (user: User) => boolean;
}

const UserActionsButtons: React.FC<UserActionsButtonsProps> = memo(({
  user,
  currentUserRole,
  onOpenActionsDialog,
  onToggleActivation,
  onTogglePOS,
  onToggleReports,
  onOpenDeleteDialog,
  isActivationButtonDisabled
}) => {
  const isSuperAdmin = currentUserRole === 'superadmin';

  return (
    <TableCell sx={{
      width: '490px',
      whiteSpace: 'nowrap',
      padding: '8px',
      height: 36
    }}>
      <Button
        variant="contained"
        color="primary"
        onClick={() => onOpenActionsDialog(user)}
        sx={{ mr: 1 }}
        disabled={isActivationButtonDisabled(user)}
      >
        Действия
      </Button>
      <Button
        variant="contained"
        color={user.deactivation === 0 ? "warning" : "success"}
        onClick={() => onToggleActivation(user)}
        sx={{ mr: 1, width: "80px" }}
        disabled={isActivationButtonDisabled(user) || (user.canToggleStatus !== undefined && !user.canToggleStatus)}
      >
        {user.deactivation === 0 ? 'Деакт' : 'Акт'}
      </Button>
      <Button
        variant="contained"
        color={user.pos === 0 ? "error" : "success"}
        onClick={() => onTogglePOS(user)}
        sx={{ mr: 1 }}
        disabled={isActivationButtonDisabled(user) || (user.canToggleStatus !== undefined && !user.canToggleStatus)}
      >
        <PointOfSale />
      </Button>
      <Button
        variant="contained"
        color={user.reports === 0 ? "error" : "success"}
        onClick={() => onToggleReports(user)}
        sx={{ mr: 1 }}
        disabled={isActivationButtonDisabled(user) || user.pos === 0 || (user.canToggleStatus !== undefined && !user.canToggleStatus)}
      >
        <span style={{ marginRight: 5 }}>Отчеты</span>
        {user.reports === 0 ? <LockOutlinedIcon /> : <LockOpenOutlinedIcon />}
      </Button>
      <Tooltip title={user.canDelete === false ? "Удаление разрешено исключительно Главному Администратору (ранг 100)" : ""}>
        <span>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => onOpenDeleteDialog(user)}
            disabled={!isSuperAdmin && user.canDelete === false}
          >
            <DeleteForeverIcon />
          </Button>
        </span>
      </Tooltip>
    </TableCell>
  );
});

UserActionsButtons.displayName = 'UserActionsButtons';

export default UserActionsButtons;

